export const projectName = process.env.REACT_APP_PROJECT_NAME;